define(["require", "exports", "tslib", "mobx", "../../utils/EntityUtil", "../entity/FAsset", "../entity/FDoc", "../entity/FInspection", "../entity/FWorksProject", "../EntityBase", "../EntityValidationState", "../../store/UserStore", "../domain", "../services", "../services/EventManager", "./FacilityReferenceData", "./FacilityWaterAgreementHistoryRecord"], function (require, exports, tslib_1, mobx_1, EntityUtil_1, FAsset_1, FDoc_1, FInspection_1, FWorksProject_1, EntityBase_1, EntityValidationState_1, UserStore_1, domain_1, services_1, EventManager_1, FacilityReferenceData_1, FacilityWaterAgreementHistoryRecord_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Facility = void 0;
    class Facility extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FileRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FileRefError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseTravellingStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseTravellingStockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseAgistingStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseAgistingStockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UsePrivate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UsePrivateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseOther", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseOtherError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspection", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFInspection", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspectionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProjectError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeAssetHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IncludeInspHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IncludeWpHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsAssetDataReady", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "FacilityReferenceData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypesDomain", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ActiveAssetTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ActiveAssetTypesDomain", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetAttributeTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserSelectabledAssetStatusTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AreDocumentsLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsWaHistoryLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "WaHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "SelectedWaHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, Facility.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FDoc = [];
            this.FInspection = [];
            this.FAsset = [];
            this.FWorksProject = [];
        }
        onRead(entity, parent) {
            this.FDoc = [];
            this.FInspection = [];
            this.FAsset = [];
            this.FWorksProject = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.FacilityId = b.FacilityId;
            a.FacilityName = b.FacilityName;
            a.FacilityType = (0, EntityUtil_1.toInt)(entity.FacilityType);
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.OwnerType = (0, EntityUtil_1.toInt)(entity.OwnerType);
            a.FileRef = b.FileRef;
            a.UseTravellingStock = (0, EntityUtil_1.toInt)(entity.UseTravellingStock);
            a.UseAgistingStock = (0, EntityUtil_1.toInt)(entity.UseAgistingStock);
            a.UsePrivate = (0, EntityUtil_1.toInt)(entity.UsePrivate);
            a.UseOther = (0, EntityUtil_1.toInt)(entity.UseOther);
            a.UserComment = b.UserComment;
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.StatusReq = (0, EntityUtil_1.toInt)(entity.StatusReq);
            a.StatusPrev = (0, EntityUtil_1.toInt)(entity.StatusPrev);
            a.StatusUser = b.StatusUser;
            a.StatusDate = b.StatusDate;
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.FDoc = this.mergeArray(a.FDoc, b.FDoc, FDoc_1.FDoc);
            a.SelectedFDoc = a.SelectedFDoc && a.FDoc.find(x => x.Id == a.SelectedFDoc.Id) ? a.SelectedFDoc : null;
            a.FInspection = this.mergeArray(a.FInspection, b.FInspection, FInspection_1.FInspection);
            a.SelectedFInspection = a.SelectedFInspection && a.FInspection.find(x => x.Id == a.SelectedFInspection.Id) ? a.SelectedFInspection : null;
            a.FAsset = this.mergeArray(a.FAsset, b.FAsset, FAsset_1.FAsset);
            a.SelectedFAsset = a.SelectedFAsset && a.FAsset.find(x => x.Id == a.SelectedFAsset.Id) ? a.SelectedFAsset : null;
            a.FWorksProject = this.mergeArray(a.FWorksProject, b.FWorksProject, FWorksProject_1.FWorksProject);
            a.SelectedFWorksProject = a.SelectedFWorksProject && a.FWorksProject.find(x => x.Id == a.SelectedFWorksProject.Id) ? a.SelectedFWorksProject : null;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.prepareAssetViewModel();
            this.addChangeEventAction("SelectedFWorksProject", () => {
                this.SelectedFWorksProject && this.SelectedFWorksProject.lazyLoad().then(() => {
                    this.disableChangeObserver();
                    this.SelectedFInspection = null;
                    this.enableChangeObserver();
                });
            });
            this.addChangeEventAction("SelectedFInspection", () => {
                this.SelectedFInspection && this.SelectedFInspection.lazyLoad().then(() => {
                    this.disableChangeObserver();
                    this.SelectedFWorksProject = null;
                    this.enableChangeObserver();
                });
            });
            this.addChangeEventAction("SystemState", () => {
                var isModelChange = false;
                let isArchiveChecked = this.SystemState == domain_1.FacilitySysStatusDomain.Archived;
                if (isArchiveChecked) {
                    if (this.Status == domain_1.FacilityStatusDomain.Archived) {
                        this.StatusReq = NaN;
                        this.SystemState = domain_1.FacilitySysStatusDomain.Archived;
                    }
                    else {
                        isModelChange = true;
                        this.StatusReq = domain_1.FacilityStatusDomain.Archived;
                        this.SystemState = domain_1.FacilitySysStatusDomain.Archived;
                    }
                }
                else {
                    if (this.Status == domain_1.FacilityStatusDomain.Archived) {
                        isModelChange = true;
                        this.StatusReq = this.StatusPrev;
                        this.SystemState = domain_1.FacilitySysStatusDomain.Active;
                    }
                    else {
                        this.StatusReq = NaN;
                        this.SystemState = domain_1.FacilitySysStatusDomain.Active;
                    }
                }
                if (isModelChange) {
                    if (!(0, UserStore_1.isUserStateGovAdminOfficer)() && this.PersistanceState == EntityBase_1.PersistanceStates.EXISTING_MODIFIED) {
                        this.PersistanceState = EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED;
                    }
                }
            });
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, Facility.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "FacilityType", "Stock Route Facility Type");
                this.validateReqString(validationState, "Lga", "LGA ");
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqNumber(validationState, "OwnerType", "Facility Ownership Type");
                this.validateReqNumber(validationState, "UseTravellingStock", "Used by Travelling Stock?");
                this.validateReqNumber(validationState, "UseAgistingStock", "Used by Agisting Stock?");
                this.validateReqNumber(validationState, "UsePrivate", "Is Privately Used?");
                this.validateReqNumber(validationState, "UseOther", "Other Usage?");
                this.validateReqNumber(validationState, "Status", "Facility Status (Actual)");
                this.validateReqString(validationState, "StatusUser", "Facility Status Changed By");
                this.validateReqDate(validationState, "StatusDate", "Facility Status Change Date");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FDoc) {
                for (let x of this.FDoc) {
                    x.walk(func, { leading });
                }
            }
            if (this.FInspection) {
                for (let x of this.FInspection) {
                    x.walk(func, { leading });
                }
            }
            if (this.FAsset) {
                for (let x of this.FAsset) {
                    x.walk(func, { leading });
                }
            }
            if (this.FWorksProject) {
                for (let x of this.FWorksProject) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                FacilityId: this.FacilityId,
                FacilityName: this.FacilityName,
                FacilityType: this.FacilityType,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                OwnerType: this.OwnerType,
                FileRef: this.FileRef,
                UseTravellingStock: this.UseTravellingStock,
                UseAgistingStock: this.UseAgistingStock,
                UsePrivate: this.UsePrivate,
                UseOther: this.UseOther,
                UserComment: this.UserComment,
                Status: this.Status,
                StatusReq: this.StatusReq,
                StatusPrev: this.StatusPrev,
                StatusUser: this.StatusUser,
                StatusDate: this.StatusDate,
                SystemState: this.SystemState,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                FDoc: this.FDoc.map(x => x.toJson()),
                FInspection: this.FInspection.map(x => x.toJson()),
                FAsset: this.FAsset.map(x => x.toJson()),
                FWorksProject: this.FWorksProject.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get RefId() {
            return `${this.FacilityId} (${this.FacilityName})`;
        }
        get LatLng() {
            return `${this.Shape.y},${this.Shape.x}`;
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.EntitySysStatusDomain.Archived;
        }
        get IsActive() {
            return this.SystemState == domain_1.EntitySysStatusDomain.Active;
        }
        get ActiveAssets() {
            return this.FAsset.filter(a => a.Status != domain_1.FAssetStatusDomain.NotPresent && a.Status != domain_1.FAssetStatusDomain.Transferred);
        }
        get ActiveAssetsDomain() {
            return domain_1.DynamicDomain.createFromArray(this.ActiveAssets, "Id", (a) => {
                return `${a.Barcode} - ${a.AssetType.AssetTypeDesc}`;
            });
        }
        get ActiveWps() {
            return this.FWorksProject.filter(a => a.Status != domain_1.FacilityWpStatusDomain.Completed);
        }
        get ActiveInsps() {
            return this.FInspection.filter(a => a.SystemState == domain_1.FacilitySysStatusDomain.Active && a.Status != domain_1.FacilityInspStatusDomain.Cancelled);
        }
        prepareAssetViewModel() {
            if (!this.IsAssetDataReady) {
                this.UserSelectabledAssetStatusTypes = domain_1.DynamicDomain.createFromDomain(domain_1.FAssetStatusDomain, [domain_1.FAssetStatusDomain.Transferred]);
                (0, EventManager_1.notify)("Loading Facility Reference Data");
                services_1.SrmsServiceManager.Instance.Facility.getFacilityReferenceData().then(res => {
                    this.FacilityReferenceData = new FacilityReferenceData_1.FacilityReferenceData(res);
                    this.AssetTypes = this.FacilityReferenceData.AssetTypes;
                    this.ActiveAssetTypes = this.AssetTypes.filter((a) => a.IsArchived == 0);
                    this.AssetAttributeTypes = this.FacilityReferenceData.AssetAttributeTypes;
                    this.AssetTypesDomain = this.createAssetTypesDomain(this.AssetTypes);
                    this.ActiveAssetTypesDomain = this.createAssetTypesDomain(this.AssetTypes);
                    this.IsAssetDataReady = true;
                });
            }
        }
        createAssetTypesDomain(assetTypes) {
            return domain_1.DynamicDomain.createFromArray(assetTypes, "Id", (at) => {
                return at.AssetTypeDesc;
            });
        }
        lazyLoadDocuments() {
            return new Promise((resolve, reject) => {
                if (this.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.AreDocumentsLoaded = true;
                }
                if (!this.AreDocumentsLoaded) {
                    this.AreDocumentsLoaded = true;
                    (0, EventManager_1.notify)("Loading Documents");
                    services_1.SrmsServiceManager.Instance.Facility.readFacilityDocuments(this.Id).then(res => {
                        this.FDoc = [];
                        res.forEach(d => {
                            this.FDoc.push(new FDoc_1.FDoc(d, this));
                        });
                        resolve(this.FDoc);
                    });
                }
                resolve([]);
            });
        }
        updateGeometry(geometry) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Facility");
                this.Shape = geometry;
                services_1.SrmsServiceManager.Instance.Facility.getFacilityLgaOnGeometryChange(this.Shape).then(res => {
                    if (res && res.LgaName && res.LgaCode) {
                        this.Lga = res.LgaName;
                        this.LgaCode = res.LgaCode;
                    }
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        }
        lazyLoadWaHistory() {
            return new Promise((resolve, reject) => {
                if (this.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.IsWaHistoryLoaded = true;
                }
                if (!this.IsWaHistoryLoaded) {
                    this.IsWaHistoryLoaded = true;
                    (0, EventManager_1.notify)("Loading WA History");
                    services_1.SrmsServiceManager.Instance.Facility.getFacilityWaterAgreementHistory(this.Id).then(res => {
                        this.WaHistory = [];
                        res.forEach(wa => {
                            this.WaHistory.push(new FacilityWaterAgreementHistoryRecord_1.FacilityWaterAgreementHistoryRecord(wa, this));
                        });
                        resolve(this.WaHistory);
                    });
                }
                resolve([]);
            });
        }
        amend() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Amending Inspection");
                services_1.SrmsServiceManager.Instance.Facility.createFacilityInspectionAmendment(this.toJson(), this.SelectedFInspection.Id).then(res => {
                    (0, EventManager_1.notify)("Amendment Complete");
                    this.merge(res.Facility);
                    this.SelectedFInspection = this.FInspection.find(x => x.Id == res.NewInspId);
                    this.IncludeInspHistory = true;
                    resolve();
                });
            });
        }
    }
    exports.Facility = Facility;
    Object.defineProperty(Facility, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility"
    });
    Object.defineProperty(Facility, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility"
    });
    Object.defineProperty(Facility, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "FacilityId", "FacilityName", "FacilityType", "Lga", "LgaCode", "OwnerType", "FileRef", "UseTravellingStock", "UseAgistingStock", "UsePrivate", "UseOther", "UserComment", "Status", "StatusReq", "StatusPrev", "StatusUser", "StatusDate", "SystemState", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "Shape"]
    });
    Object.defineProperty(Facility, "FacilityIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(Facility, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "FacilityNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 70
    });
    Object.defineProperty(Facility, "FacilityNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "FacilityTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "FacilityTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 128
    });
    Object.defineProperty(Facility, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(Facility, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "OwnerTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "OwnerTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "FileRefLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Facility, "FileRefReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "UseTravellingStockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "UseAgistingStockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "UsePrivateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "UseOtherReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "UserCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(Facility, "UserCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "StatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "StatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "StatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "StatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "StatusUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Facility, "StatusUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "StatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Facility, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Facility, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Facility, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Facility, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FacilityTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "OwnerType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "OwnerTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FileRef", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FileRefError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseTravellingStock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseTravellingStockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseAgistingStock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseAgistingStockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UsePrivate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UsePrivateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseOther", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UseOtherError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UserComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "UserCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SelectedFDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FInspection", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SelectedFInspection", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FInspectionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SelectedFAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SelectedFWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "FWorksProjectError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Facility.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "IncludeAssetHistory", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "IncludeInspHistory", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "IncludeWpHistory", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "RefId", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "LatLng", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "ActiveAssets", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "ActiveAssetsDomain", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "ActiveWps", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Facility.prototype, "ActiveInsps", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "IsAssetDataReady", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Facility.prototype, "prepareAssetViewModel", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "AreDocumentsLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Facility.prototype, "lazyLoadDocuments", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "IsWaHistoryLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "WaHistory", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Facility.prototype, "SelectedWaHistory", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Facility.prototype, "lazyLoadWaHistory", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Facility.prototype, "amend", null);
});
